import ActionsLogIcon from './component'

export default ActionsLogIcon